import Honeybadger from '@honeybadger-io/js'
import { isAxiosError } from 'axios'
import config from '@/config'
import redactRequestError from '@/utilities/redactRequestError'
import thirdPartyErrorFilter from '@/utilities/thirdPartyErrorFilter'

const honeybadger = Honeybadger.configure(config.honeyBadger)
honeybadger.beforeNotify(thirdPartyErrorFilter)

class Log {
  private static honeybadger = honeybadger

  static storeReset(file: string, functionName: string | null = null) {
    this.honeybadger.addBreadcrumb('Pinia store reset', {
      category: 'log',
      metadata: {
        file: file,
        function: functionName || '',
      },
    })
  }

  static storeResetExcludingUser(
    file: string,
    functionName: string | null = null,
  ) {
    this.honeybadger.addBreadcrumb('Pinia store excluding user reset', {
      category: 'log',
      metadata: {
        file: file,
        function: functionName || '',
      },
    })
  }

  static siteStoreReset(file: string, functionName: string | null = null) {
    this.honeybadger.addBreadcrumb('Site store reset', {
      category: 'log',
      metadata: {
        file: file,
        function: functionName || '',
      },
    })
  }

  static customerStoreReset(file: string, functionName: string | null = null) {
    this.honeybadger.addBreadcrumb('Customer store reset', {
      category: 'log',
      metadata: {
        file: file,
        function: functionName || '',
      },
    })
  }

  static genericBreadcrumb(message: string, data: unknown) {
    this.honeybadger.addBreadcrumb(message, {
      category: 'log',
      metadata: {
        data,
      },
    })
  }

  static notify(error: Error, name: string) {
    if (!isAxiosError(error)) {
      this.honeybadger.notify(error, name)

      return
    }

    // A failed request's error carries its config: a document link's signed token and the
    // session's token. Only the redacted description of the request is reported.
    const reported = new Error(error.message)
    reported.name = error.name
    reported.stack = error.stack

    this.honeybadger.notify(reported, name, {
      context: { request: redactRequestError(error) },
    })
  }

  static getHoneybadger() {
    return this.honeybadger
  }
}

export default Log
